import { render, staticRenderFns } from "./ControlledVocabulary.vue?vue&type=template&id=89bab8b8&"
import script from "./ControlledVocabulary.vue?vue&type=script&lang=ts&"
export * from "./ControlledVocabulary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports